import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.format()
    this.element.addEventListener("input", this.format.bind(this))
  }

  disconnect() {
    this.element.removeEventListener("input", this.format.bind(this))
  }

  format() {
    const digits = this.element.value.replace(/\D/g, "").slice(0, 9)
    const parts = []

    if (digits.length > 0) parts.push(digits.slice(0, 3))
    if (digits.length >= 4) parts.push(digits.slice(3, 5))
    if (digits.length >= 6) parts.push(digits.slice(5, 9))

    this.element.value = parts.join("-")
  }
}
